export default __webpack_public_path__ + "static/media/Group 3099.87cbd10d.svg";